import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";

const RequirePermission = ({ moduleKey, action = "read" }) => {
  const { isAuthenticated, hasPermission } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/auth/login" replace />;
  }

  if (!moduleKey) {
    return <Outlet />;
  }

  if (!hasPermission(moduleKey, action)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default RequirePermission;
